import React from "react";
import { Link as GatsbyLink } from "gatsby";
import { useI18next } from "../../../plugins/gatsby-plugin-ap-i18next/src/useI18next";

import {
    footer,
    hidden,
    upper,
    lower,
    social,
    logo,
    button,
    logoAp,
    logoAmc,
    links,
    footerLink,
} from "./footer.module.scss";
import getFooterLinks from "../../utils/get-footer-links";
import LogoAP from "../../assets/images/svg/cat_ap_logo.svg";
import logoAPCat from "../../assets/images/logo_ap_cat.png";
import logoAMComp from "../../assets/images/logo_amc_gold.png";

import Logo from "../atoms/logo";
import Facebook from "../../assets/images/svg/facebook.svg";
import Instagram from "../../assets/images/svg/instagram.svg";
import Link from "../atoms/link";
import Logo2 from "../atoms/logo2";
import { breakpoints } from "../../config/breakpoints";
import useMediaQuery from "../../hooks/use-media-query";

interface IFooterProps {
    isVisible?: boolean;
}

const Footer: React.FC<IFooterProps> = ({ isVisible = true }) => {
    const footerLinks = getFooterLinks("footerLinks");
    const { t } = useI18next();

    const isTablet = useMediaQuery(breakpoints.tablet);

    return (
        <footer className={`${footer} ${isVisible ? "" : hidden}`}>
            <div className={upper}>
                {!isTablet && <GatsbyLink to="/" className={logo}>
                    <Logo2 color="white" type="logo" />
                </GatsbyLink>}
                <div className={links}>
                    {footerLinks.map(({ key, url, translationKey, external }) => {
                        if (translationKey) {
                            return (
                                <Link
                                    key={`footer-link-${key}`}
                                    to={url}
                                    className={footerLink}
                                    external={external}
                                >
                                    {t(translationKey)}
                                </Link>
                            );
                        }
                        return null;
                    })}
                </div>
                <div className={social}>
                    <Link
                        external
                        color="white"
                        to={getFooterLinks("socialLinks", "instagram")}
                        className={button}
                    >
                        <Instagram />
                    </Link>
                    <Link
                        external
                        color="white"
                        to={getFooterLinks("socialLinks", "facebook")}
                        className={button}
                    >
                        <Facebook />
                    </Link>
                </div>
            </div>
            <div className={lower}>
                <p>Copyright © 2025 Fashion Fairy</p>
                <p>
                    Created by{" "}
                    <a href="https://www.instagram.com/aery_pantery/" target="_blank" rel="noreferrer">
                        <img src={logoAPCat} className={logoAp} />
                        {/* <LogoAPCat className={logoAp} /> */}
                    </a>
                </p>
                <p>
                    Development by{" "}
                    <a href="https://amcomp.pl" target="_blank" rel="noreferrer">
                        <img src={logoAMComp} className={logoAmc} />
                    </a>
                </p>
            </div>
        </footer>
    );
};

export default Footer;
